import 'lite-youtube-embed';

export default {
	init() {
		window.addEventListener('load', () => {
			const embeds = document.querySelectorAll('lite-youtube');
			const isMobileDevice = /Mobi/i.test(window.navigator.userAgent);

			if (!embeds || !isMobileDevice) {
				return;
			}

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.activate();
							observer.unobserve(entry.target);
						}
					});
				},
				{
					threshold: 0.1,
				},
			);

			embeds.forEach((embed) => {
				observer.observe(embed);
			});
		});
	},
};
